export interface LastCallsListProps {
  readonly id: number;
  readonly name: string;
  readonly created_at: Date;
  readonly address: string | null;
  readonly address_reference: string | null;
  readonly location: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly is_prank_call: string;
  readonly is_recall: string;
  readonly type: {
    readonly id: number;
    readonly name: string;
  } 
  readonly entry_status: {
    readonly id: number;
    readonly name: string;
  }
  readonly subtype: {
    readonly id: number;
    readonly name: string;
  },
  readonly occurrence: {
    readonly id: number,
    readonly closed_at: string,
    readonly dispatches: readonly [
      {
        readonly id: number,
        readonly code: string,
        readonly status_id: number,
        readonly status: {
          readonly id: number,
          readonly name: string,
          readonly acronym: string,
          readonly created_at: string,
          readonly updated_at: string,
          readonly deleted_at: null
        },
        readonly state: {
          readonly context: string,
          readonly status_id: number
        }
      }
    ]
  }
}

export interface filtersProps {
  readonly hide: boolean
  readonly content: ReadonlyArray<any>
  readonly fields: {
    readonly id: string | null
    readonly lastCallsFilter: string | null
    readonly lasCallsGroupFilter: string | null
    readonly typeFilter: string | null
    readonly name: string | null
    readonly phone: string | null
  }
}

export const filtersDefault: filtersProps = {
  hide: true,
  content: [],
  fields: {
    id: null,
    lastCallsFilter: null,
    lasCallsGroupFilter: null,
    typeFilter: null,
    name: null,
    phone: null,
  },
}

export interface dispatchDestinationProps {
  readonly id: number
  readonly code: string
}